@if (knobPosition() === 'start') {
  <span class="knob"></span>
}
@if (icon(); as glyph) {
  <i [class]="iconClass()">{{ glyph }}</i>
}
@if (label()) {
  <span class="l">{{ label() }}</span>
}
@if (knobPosition() === 'end') {
  <span class="knob"></span>
}
